import Modal from "react-bootstrap/Modal";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import TextArea from "../sharedComponents/textarea/textArea";
import { useEffect, useState } from "react";
import FileUploader from "../reusableComponents/fileUploader";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Alerts from "../reusableComponents/alert";
import FilesList from "../reusableComponents/filesList";
import Button from "../sharedComponents/buttons/button";
import "../tasks/tasksStyle.css";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { removeItem } from "../../algorithms/listsAlogrithms";
import { useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  addProjectForm,
  getCommunityProjectForm,
} from "../../API/store/actions/projects/projects";
import MembersList from "../../algorithms/listsAlogrithms";
import { englishDate } from "../../algorithms";

const CreateNewProject = (props) => {
  const { onHide, communityId, setProjAdded, projAdded } = props;
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);

  const [AdminMembersList, setAdminMembersList] = useState([]);
  const [MemberList, setMemberList] = useState([]);
  const [ProjectStatusDropdownList, setProjectStatusDropdownList] = useState(
    []
  );
  const [PriorityDropdownList, setPriorityDropdownList] = useState([]);
  const [ProjectTypeDropdownList, setProjectTypeDropdownList] = useState([]);

  const [dropdowns, setDrobdowns] = useState({});
  const userToken = useSelector((state) => state.login.userToken);

  useEffect(() => {
    resolver(getCommunityProjectForm, setDrobdowns, communityId, userToken);
  }, [communityId]);

  useEffect(() => {
    if (dropdowns?.data?.members) {
      setAdminMembersList(dropdowns?.data?.members);
      setMemberList(dropdowns?.data?.members);
    }
    if (dropdowns?.data?.priorityLkp)
      setPriorityDropdownList(dropdowns?.data?.priorityLkp);
    if (dropdowns?.data?.projectStatusLkp)
      setProjectStatusDropdownList(dropdowns?.data?.projectStatusLkp);
    if (dropdowns?.data?.projectTypeLkp)
      setProjectTypeDropdownList(dropdowns?.data?.projectTypeLkp);
  }, [dropdowns]);

  const [files, setFiles] = useState([]);

  const [adminListError, setAdminListError] = useState(false);

  const [duplicateAlert, setDuplicateAlert] = useState(false);

  const userLogged = useSelector((state) => state.login.userData);
  const [disable, setDisable] = useState(false);

  const saveHandler = async (values) => {
    let formData = new FormData();

    const newData = {
      Name_A: values.Name,
      Name_E: values.Name,
      Description_A: values.Description,
      Description_E: values.Description,
      StartDate: englishDate(values.StartDate) + "T00:00:00",
      EndDate: englishDate(values.EndDate) + "T00:00:00",
      CommunityId: communityId, // will be changed when we send id from community slider to here and we will change it on api also
      OwnerId: userLogged.id,
      ProjectStatusId: parseInt(values.ProjectStatusId),
      PriorityId: parseInt(values.PriorityId),
      ProjectTypeId: parseInt(values.ProjectTypeId),
      AdminMembers: values.AdminMembers,
      Members: values.Members,
      Files: values.files,
    };

    for (let [key, value] of Object.entries(newData)) {
      if (key == "Files") {
        value.forEach((element) => {
          formData.append("Files", element.file);
        });
      } else if (key == "AdminMembers") {
        value.forEach((element) => {
          formData.append("AdminMembers", element);
        });
      } else if (key == "Members") {
        value.forEach((element) => {
          formData.append("Members", element);
        });
      } else {
        formData.append(key, value);
      }
    }

    if (startDateError === false && endDateError === false) {
      if (values.AdminMembers.length > 0) {
        setAdminListError(false);
        if (disable) {
          return;
        } else {
          setDisable(true);
        }
        let res = await addProjectForm(formData, userToken);
        if (res.status <= 206) {
          setPriorityDropdownList(dropdowns.data.priorityLkp);
          setProjectStatusDropdownList(dropdowns.data.projectStatusLkp);
          setProjectTypeDropdownList(dropdowns.data.projectTypeLkp);
          setFiles([]);
          setStartDate("");
          setEndDate("");
          resetForm();
          onHide();
          setProjAdded(!projAdded);
          setDisable(false);
        } else {
          setDisable(false);
        }
      } else {
        setAdminListError(true);
        setDisable(false);
      }
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "createProjectPopup",
      saveHandler
    )
  );

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
    resetForm,
  } = formik;

  if (
    dropdowns?.data?.members &&
    dropdowns?.data?.priorityLkp &&
    dropdowns?.data?.projectStatusLkp &&
    dropdowns?.data?.projectTypeLkp
  ) {
    return (
      <Modal
        // show={show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  height: 32,
                  width: 32,
                }}
              >
                <img
                  src="/assets/images/Group 8261.png"
                  width={40}
                  height={30}
                />
              </div>
              <div className="text-dark">
                <p
                  className="my-0 mx-1"
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "#1a73e8",
                  }}
                >
                  {Lang.addProject}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"#1A73E8"}
              onclick={() => {
                onHide();
                setPriorityDropdownList(dropdowns.data.priorityLkp);
                setProjectStatusDropdownList(dropdowns.data.projectStatusLkp);
                setProjectTypeDropdownList(dropdowns.data.projectTypeLkp);
                setFiles([]);
                setStartDate("");
                setEndDate("");
                resetForm();
                setAdminListError(false);
                setDisable(false);
              }}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <form onSubmit={handleSubmit}>
            <TextArea
              name={"Name"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.title + "*"}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Name")}
            />

            <TextArea
              name={"Description"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.Description}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Description")}
            />

            <div className="d-flex flex-xl-row justify-content-center col-12 flex-column mt-4">
              <div
                className={`d-flex flex-column align-items-center col-12 my-2 px-xl-5`}
              >
                <p className="mb-3 px-4 px-xl-2 col-12">
                  {Lang.periodTime + "*"}
                </p>
                <div className="d-flex col-12 flex-xl-row flex-column align-items-center align-items-xl-start">
                  <div
                    className={`d-flex align-items-center align-items-xl-start flex-column col-11 col-xl-4 mb-xl-2 ${styleStart(
                      "m",
                      2
                    )} ${styleStart("m", 0, "xl")}`}
                  >
                    <div className="col-12 align-items-center align-items-xl-start mb-xl-0 mb-3">
                      <DateInput
                        errorMessage={
                          formikValidation(touched, errors, "StartDate") ||
                          startDateError === true
                            ? Lang.invalidDate
                            : null
                        }
                        style={{ padding: "21.5px" }}
                        placeholder={Lang.from}
                        containerStyle={"col-12"}
                        name={"StartDate"}
                        value={values.StartDate}
                        onChange={(e) => {
                          setFieldValue("StartDate", e);
                          if (values.EndDate)
                            if (new Date(values.EndDate) >= new Date(e)) {
                              setEndDateError(false);
                              setStartDateError(false);
                            } else setStartDateError(true);
                        }}
                        iconPrefix="far"
                        iconName="calendar"
                        iconSize={22}
                      />
                    </div>
                  </div>

                  <div
                    className={`d-flex flex-column align-items-center col-11 col-xl-4 mb-2 ${styleStart(
                      "m",
                      2
                    )}`}
                  >
                    <div className="col-12 align-items-center">
                      <DateInput
                        errorMessage={
                          formikValidation(touched, errors, "EndDate") ||
                          endDateError === true
                            ? Lang.invalidDate
                            : null
                        }
                        style={{ padding: "21.5px" }}
                        placeholder={Lang.to}
                        containerStyle={"col-12"}
                        value={values.EndDate}
                        onChange={(e) => {
                          setFieldValue("EndDate", e);

                          if (values.StartDate)
                            if (new Date(values.StartDate) <= new Date(e)) {
                              setEndDateError(false);
                              setStartDateError(false);
                            } else setEndDateError(true);
                        }}
                        iconPrefix="far"
                        iconName="calendar"
                        iconSize={22}
                      />
                    </div>
                    {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
                  </div>

                  <DropDownList
                    placeholder={Lang.priority + "*"}
                    border={true}
                    containerStyle={"col-xl-4 col-11 mb-3 my-xl-0 px-xl-2"}
                    dataSource={PriorityDropdownList}
                    value={values.PriorityId}
                    change={(e) => {
                      setFieldValue("PriorityId", e.value);
                    }}
                    errorMessage={formikValidation(
                      touched,
                      errors,
                      "PriorityId"
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-xl-row align-items-center col-12 flex-column mb-4">
              <DropDownList
                placeholder={Lang.projectStatus + "*"}
                border={true}
                containerStyle={`col-xl-6 col-11 mb-3 my-xl-0 ${styleStart(
                  "p",
                  5,
                  "xl"
                )} ${styleEnd("p", 2, "xl")}`}
                dataSource={ProjectStatusDropdownList}
                value={values.ProjectStatusId}
                change={(e) => {
                  setFieldValue("ProjectStatusId", e.value);
                }}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "ProjectStatusId"
                )}
              />

              <DropDownList
                placeholder={Lang.projectType + "*"}
                border={true}
                containerStyle={`col-xl-6 col-11 mb-3 my-xl-0 ${styleEnd(
                  "p",
                  5,
                  "xl"
                )}`}
                dataSource={ProjectTypeDropdownList}
                value={values.ProjectTypeId}
                change={(e) => {
                  setFieldValue("ProjectTypeId", e.value);
                }}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "ProjectTypeId"
                )}
              />
            </div>

            <MembersList
              onChangeSearch={(e) => {
                let searchKey = e.target.value; //HERE FILTER
                setAdminMembersList(
                  [
                    ...dropdowns?.data?.members.filter(
                      (member) =>
                        ![...values.Members].some(
                          (admin) => admin.memberId == member.memberId
                        )
                    ),
                  ].filter((item) => item.memberName.includes(searchKey))
                );
              }}
              containerStyle="d-flex flex-column mx-xl-4 mx-3 my-4 col-12"
              aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={Lang.addAdmainMembers + "*"}
              cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                "TitleCard"
              )}`}
              cardTitle={Lang.adminMembers}
              list={AdminMembersList}
              id={"A"}
              checked={true}
              values={values.AdminMembers}
              onChange={(e) => {
                if (e.target.checked) {
                  setFieldValue("AdminMembers", [
                    ...values.AdminMembers,
                    parseInt(e.target.value),
                  ]);
                  setMemberList(
                    MemberList.filter(
                      (item) =>
                        parseInt(item.memberId) !== parseInt(e.target.value)
                    )
                  );
                  setAdminListError(false);
                } else {
                  setMemberList([
                    AdminMembersList.find(
                      (item) =>
                        parseInt(e.target.value) === parseInt(item.memberId)
                    ),
                    ...MemberList,
                  ]);
                  setFieldValue(
                    "AdminMembers",
                    removeItem(values.AdminMembers, parseInt(e.target.value))
                  );
                  if (values.AdminMembers.length > 0) {
                    setAdminListError(false);
                  } else {
                    setAdminListError(true);
                  }
                }
              }}
              listError={adminListError}
            />

            <MembersList
              onChangeSearch={(e) => {
                let searchKey = e.target.value; //HERE FILTER
                setMemberList(
                  [
                    ...dropdowns?.data?.members.filter(
                      (member) =>
                        ![...values.AdminMembers].some(
                          (admin) => admin.memberId == member.memberId
                        )
                    ),
                  ].filter((item) => item.memberName.includes(searchKey))
                );
              }}
              containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-5 col-12"
              aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={Lang.addMembers}
              cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                "TitleCard"
              )}`}
              id={"B"}
              checked={true}
              values={values.Members}
              cardTitle={Lang.Members}
              list={MemberList}
              onChange={(e) => {
                if (e.target.checked) {
                  setFieldValue("Members", [
                    ...values.Members,
                    parseInt(e.target.value),
                  ]);
                  setAdminMembersList([
                    ...AdminMembersList.filter(
                      (item) =>
                        parseInt(item.memberId) !== parseInt(e.target.value)
                    ),
                  ]);
                } else {
                  setAdminMembersList([
                    MemberList.find(
                      (item) =>
                        parseInt(e.target.value) === parseInt(item.memberId)
                    ),
                    ...AdminMembersList,
                  ]);
                  setFieldValue(
                    "Members",
                    removeItem(values.Members, parseInt(e.target.value))
                  );
                }
              }}
              listError={false}
            />

            <div className="col-12 px-4 px-xl-5">
              <Alerts
                variant={"danger"}
                buttonContent={
                  getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
                }
                content={
                  getDir(getCurrentLangFromRedux()) == "rtl"
                    ? "هذا الملف تم رفعه من قبل"
                    : "this file uploaded already"
                }
                title={
                  getDir(getCurrentLangFromRedux()) == "rtl"
                    ? "ملف متكرر"
                    : "duplicate file"
                }
                show={duplicateAlert}
                setShow={setDuplicateAlert}
              />
            </div>

            <div className="d-flex flex-column mx-4 px-xl-4 mb-3">
              <FileUploader
                containerStyle={"col-12"}
                contentStyle={"col-12"}
                borderColor={"#C7C7C9"}
                placeholderLTRWidth={150}
                placeholderRTLWidth={115}
                fileIconColor={"#1a73e8"}
                fileValue={values.file}
                fileOnClick={(e) => {
                  e.target.value = "";
                  setFieldValue("file", e.target.value);
                }}
                FileOnChange={(e) => {
                  setFieldValue("file", e.target.files[0]);
                }}
                uploadButtonOnChange={() => {
                  if (values.file) {
                    if (
                      !files.find(
                        (item) =>
                          item.fileName === values.file.name.substr(0, 35)
                      )
                    ) {
                      const allFiles = [
                        ...files,
                        {
                          id: files.length + 1,
                          fileName: values.file.name.substr(0, 35),
                          file: values.file,
                        },
                      ];
                      setFieldValue("files", [...allFiles]);
                      setFiles([...allFiles]);
                      setFieldValue("file", "");
                      setFieldTouched("files", false);
                    } else {
                      setDuplicateAlert(true);
                      setTimeout(() => {
                        setDuplicateAlert(false);
                      }, 1000);
                    }
                  }
                }}
              />
              <FilesList
                containerStyle={"col-12 justify-content-start"}
                contentStyle={"col-12"}
                Data={[...files]}
                setFiles={setFiles}
                setFilesInFormik={setFieldValue}
                setFilesTouched={setFieldTouched}
                propInFormik={"files"}
              />
            </div>

            <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
              <Button
                disable={disable}
                content={disable ? Lang.saving : Lang.save}
                containerStyle="col-3 mx-3"
                onClick={() => {
                  if (values.AdminMembers.length > 0) setAdminListError(false);
                  else setAdminListError(true);
                }}
                type={"submit"}
                buttonStyleType={"solid"}
              />

              <Button
                content={Lang.cancel}
                containerStyle="col-3 mx-3"
                onClick={() => {
                  onHide();
                  setPriorityDropdownList(dropdowns.data.priorityLkp);
                  setProjectStatusDropdownList(dropdowns.data.projectStatusLkp);
                  setProjectTypeDropdownList(dropdowns.data.projectTypeLkp);
                  setFiles([]);
                  setStartDate("");
                  setEndDate("");
                  resetForm();
                  setAdminListError(false);
                  setDisable(false);
                }}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  } else {
    return null;
  }
};
export default CreateNewProject;
